import React, { useState } from 'react'
import styles from './InfoItem.module.css'
import { Button, message, Switch } from 'antd'
export default function InfoItem(props) {
    const [messageApi, contextHolder] = message.useMessage()


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.title}
        </td>
        <td
            className={styles.td1}
        >{props.item.jifen}
        </td>
        <td
            className={styles.td1}
        >{props.item.xiazai_num}
        </td>
        <td
            className={styles.td1}
        >{props.item.size}
        </td>
        <td
            className={styles.td1}
        >
            <Switch
                checked={props.item.status == 1}
                onChange={(checked) => {
                    console.log(checked);
                    props.changeStatus(props.item, checked);
                }}
                checkedChildren="开"
                unCheckedChildren="关"
                // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                style={{marginLeft: 10, marginRight: 10}}
            />

        </td>
        <td
            className={styles.td1}
        >{props.item.ctime}
        </td>
        <td
            className={styles.td1}
        >
            <Button
                color="primary"
                variant="link"
                onClick={() => {
                    props.editMethod(props.item);
                }}
            >
            编辑
          </Button>
        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

